import React from 'react';
import styled from 'styled-components';
import Scrollchor from 'react-scrollchor';
import { CtaButton } from '../styled';

const ButtonContainer = styled.div`
  text-align: center;
  padding-bottom: 50px;
`;

const IndiButton = styled(CtaButton)`
  width: auto;
  min-width: 240px;
  padding: 0 22px;
  background: #1e5cb3;
  color: #ffffff;

  &:hover {
    background: #3f81df;
  }

  &:active {
    background: #133a71;
  }
`;
// const CtaButton = styled.button`
//   background: #1e5cb3;
//   color: white;
//   padding: 0 78px;
//   border: none;
//   border-radius: 25px;
//   outline: none;
//   font-size: 14px;
//   line-height: 50px;
//   text-transform: uppercase;
// `;

function IndividualCtaButton({ input }) {
  return (
    <ButtonContainer>
      {input.primary.scroll_anchor_id && (
        <Scrollchor to={input.primary.scroll_anchor_id.text}>
          <IndiButton type="button">{input.primary.label.text}</IndiButton>
        </Scrollchor>
      )}
      {input.primary.link && (
        <a href={input.primary.link.url}>
          <IndiButton type="button" color={input.primary.color}>{input.primary.label.text}</IndiButton>
        </a>
      )}
    </ButtonContainer>
  );
}

export { IndividualCtaButton };
